import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveFormField from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    (payload.type === "FormField" || payload.type === "TextInput")
  ) {
    return [LiveFormField];
  }
};
